
export default {
    NEW_ID: '_new_',

    ALL_ID: '_all_',

    BUSINESS_LOGIC:
        {
            GOOGLE_TAG_MANAGER: {
                ID: process.env.GOOGLE_TAG_MANAGER_ID,
                AUTH: process.env.GOOGLE_TAG_MANAGER_AUTH,
                PREVIEW: process.env.GOOGLE_TAG_MANAGER_PREVIEW
            },
            GOOGLE_RECAPTCHA_SITE_KEY: process.env.NODE_ENV === 'development' ? '6Lf783oeAAAAAA5rzjS8cmHoJgE_0wvpqPj5ysiI' : '6LeV5noeAAAAAIfvaZPZzB3i8O89wC4K2AXwVKQz',
            HOTEL_REVIEWS:
                {
                    AUTHOR_TYPE: {
                        MEMBER: 'Member', USER: 'User',
                    },
                    STATUS: {
                        PENDING: 'Pending', APPROVED: 'Approved', DECLINED: 'Declined',
                    },
                },
            HUBSPOT_FORM: {
                FORM_ID: process.env.NODE_ENV === 'development' ? 'cd8eff1d-e0b7-4d9c-a318-1f23bddc99f6' : 'a221a58a-f944-42f3-b4d2-ccead1f850fd',
                PORTAL_ID: process.env.NODE_ENV === 'development' ? '49270902' : '48322207',
                HOTEL_IDS: [],
            },
            PAYMENT_GATEWAYS: {
                AUTHORIZE: 'Authorize',
                CENPOS: 'CenPOS',
            },
            PAYMENT_GATEWAY_PROFILE_TYPES: {
                MEMBER: 'Member',
            },
            PAYMENT_METHODS: {
                CREDIT_CARD: 'Credit Card',
                DEBIT_CARD: 'Debit Card',
                GIFT_CARD: 'Gift Card',
                ACH: 'ACH',
            },
            PAYMENT_STATUS: {
                PAID: 'Paid',
                PENDING: 'Pending',
                ALL: '_payment_status_internal_',

                MEMBER_REWARDS: {
                    CASHOUT_TYPES: {
                        ZELLE: 'ZELLE',
                        BOOKING: 'BOOKING',
                        TRAVEL_CREDIT: 'TRAVEL_CREDIT',
                    },
                },

            },
            TESTIMONIALS:
                {
                    STATUS: {
                        PENDING: 'Pending', APPROVED: 'Approved', DECLINED: 'Declined',
                    },
                },
            SCHEDULE_CALL_LINKS: {
                DEFAULT: 'https://48322207.hs-sites.com/schedule-a-call',
                AFRICA: 'https://meetings.hubspot.com/luxuria-meetings?uuid=6070b0dc-a800-4c4a-8345-3ddb05096f18',
            },
            REGION_IDS: {
                AFRICA: process.env.AFRICA_REGION_ID || 17,
            },
        },
};
